import Vue from 'vue'
import Vuex from 'vuex'

import getters from './getters'
import actions from './actions'
import start from './state'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: start,
  actions,
  getters,

  mutations: {
    SET_PRODUCTS(state, { products }) {
      state.products = products
    },

    SET_CHECKOUT(state, { checkout }) {
      state.checkout = checkout
    },

    MENU_TRIGGER(state, { trigger }) {
      state.isMenuOpen = trigger
    },

    CART_TRIGGER(state, { trigger }) {
      state.isCartOpen = trigger
    },

    SET_DATA(state, data) {
      Object.assign(state, data)
    },

    SET_SMOOTH(state, { smooth }) {
      state.scrollbar = smooth
    },

    SET_STATE_HERO(state, bool) {
      state.enableSlider = bool
    },

    SET_IS_IN_TRANSITION(state, bool) {
      state.isInTransition = bool
    },

    SET_TRANSITION_STATE(state, obj) {
      state.transition = obj
    },

    SET_IS_MENU_IN_TRANSITION(state, bool) {
      state.isMenuInTransition = bool
    }
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js